import { createAction, props } from '@ngrx/store';
import { IDataAction } from '../../utils/interfaces/common.interfaces';
import { CcapTokenDetails, Company, CompanyDetails, CompanyLink, CompanyLinkCompany, User, UserDetails } from 'src/app/generated/CrossPoint.IdentityManagement.Server';
import { IGetCompaniesData, IGetUsersData } from 'src/app/utils/interfaces/remote-maintenance.interfaces';
import { ApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';
import { INewCcapTokens, INewCompany, INewUser, IRevokeCcapToken, IUnlinkOrLinkInstaller, IUpdateCompany, IUpdateUser, IUserPermissions } from 'src/app/utils/interfaces/store.interfaces';

export enum IdentityManagementActionsTypes {
  GET_AUTH_INFO_IDENTITY_MANAGEMENT = '[IDENTITY_MANAGEMENT] AUTH_INFO_IDENTITY_MANAGEMENT',
  GET_AUTH_INFO_IDENTITY_MANAGEMENT_SUCCESS = '[IDENTITY_MANAGEMENT] AUTH_INFO_IDENTITY_MANAGEMENT_SUCCESS',
  GET_AUTH_INFO_IDENTITY_MANAGEMENT_FAILED = '[IDENTITY_MANAGEMENT] AUTH_INFO_IDENTITY_MANAGEMENT_FAILED',

  GET_AUTH_INFO_FOR_COMPANY = '[IDENTITY_MANAGEMENT] GET_AUTH_INFO_FOR_COMPANY',
  GET_AUTH_INFO_FOR_COMPANY_SUCCESS = '[IDENTITY_MANAGEMENT] GET_AUTH_INFO_FOR_COMPANY_SUCCESS',
  GET_AUTH_INFO_FOR_COMPANY_FAILED = '[IDENTITY_MANAGEMENT] GET_AUTH_INFO_FOR_COMPANY_FAILED',

  GET_AUTH_INFO_FOR_USER = '[IDENTITY_MANAGEMENT] GET_AUTH_INFO_FOR_USER',
  GET_AUTH_INFO_FOR_USER_SUCCESS = '[IDENTITY_MANAGEMENT] GET_AUTH_INFO_FOR_USER_SUCCESS',
  GET_AUTH_INFO_FOR_USER_FAILED = '[IDENTITY_MANAGEMENT] GET_AUTH_INFO_FOR_USER_FAILED',

  GET_DEALER_COMPANIES = '[IDENTITY_MANAGEMENT] GET_DEALER_COMPANIES',
  GET_DEALER_COMPANIES_SUCCESS = '[IDENTITY_MANAGEMENT] GET_DEALER_COMPANIES_SUCCESS',
  GET_DEALER_COMPANIES_FAILED = '[IDENTITY_MANAGEMENT] GET_DEALER_COMPANIES_FAILED',

  GET_RETAILER_COMPANIES = '[IDENTITY_MANAGEMENT] GET_RETAILER_COMPANIES',
  GET_RETAILER_COMPANIES_SUCCESS = '[IDENTITY_MANAGEMENT] GET_RETAILER_COMPANIES_SUCCESS',
  GET_RETAILER_COMPANIES_FAILED = '[IDENTITY_MANAGEMENT] GET_RETAILER_COMPANIES_FAILED',

  GET_INSTALLER_COMPANIES = '[IDENTITY_MANAGEMENT] GET_INSTALLER_COMPANIES',
  GET_INSTALLER_COMPANIES_SUCCESS = '[IDENTITY_MANAGEMENT] GET_INSTALLER_COMPANIES_SUCCESS',
  GET_INSTALLER_COMPANIES_FAILED = '[IDENTITY_MANAGEMENT] GET_INSTALLER_COMPANIES_FAILED',

  GET_COMPANIES = '[IDENTITY_MANAGEMENT] GET_COMPANIES',
  GET_COMPANIES_SUCCESS = '[IDENTITY_MANAGEMENT] GET_COMPANIES_SUCCESS',
  GET_COMPANIES_FAILED = '[IDENTITY_MANAGEMENT] GET_COMPANIES_FAILED',

  GET_COMPANY_INFO = '[IDENTITY_MANAGEMENT] GET_COMPANY_INFO',
  GET_COMPANY_INFO_SUCCESS = '[IDENTITY_MANAGEMENT] GET_COMPANY_INFO_SUCCESS',
  GET_COMPANY_INFO_FAILED = '[IDENTITY_MANAGEMENT] GET_COMPANY_INFO_FAILED',

  UPDATE_COMPANY = '[IDENTITY_MANAGEMENT] UPDATE_COMPANY_INFO',
  UPDATE_COMPANY_SUCCESS = '[IDENTITY_MANAGEMENT] UPDATE_COMPANY_INFO_SUCCESS',
  UPDATE_COMPANY_FAILED = '[IDENTITY_MANAGEMENT] UPDATE_COMPANY_INFO_FAILED',

  CREATE_COMPANY = '[IDENTITY_MANAGEMENT] CREATE_COMPANY',
  CREATE_COMPANY_SUCCESS = '[IDENTITY_MANAGEMENT] CREATE_COMPANY_SUCCESS',
  CREATE_COMPANY_FAILED = '[IDENTITY_MANAGEMENT] CREATE_COMPANY_FAILED',

  SET_COMPANY = '[IDENTITY_MANAGEMENT] SET_COMPANY',

  GET_USERS = '[IDENTITY_MANAGEMENT] GET_USERS',
  GET_USERS_SUCCESS = '[IDENTITY_MANAGEMENT] GET_USERS_SUCCESS',
  GET_USERS_FAILED = '[IDENTITY_MANAGEMENT] GET_USERS_FAILED',

  GET_USER = '[IDENTITY_MANAGEMENT] GET_USER',
  GET_USER_SUCCESS = '[IDENTITY_MANAGEMENT] GET_USER_SUCCESS',
  GET_USER_FAILED = '[IDENTITY_MANAGEMENT] GET_USER_FAILED',

  GET_USER_DETAILS = '[IDENTITY_MANAGEMENT] GET_USER_DETAILS',
  GET_USER_DETAILS_SUCCESS = '[IDENTITY_MANAGEMENT] GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_FAILED = '[IDENTITY_MANAGEMENT] GET_USER_DETAILS_FAILED',

  DELETE_USER = '[IDENTITY_MANAGEMENT] DELETE_USER',
  DELETE_USER_SUCCESS = '[IDENTITY_MANAGEMENT] DELETE_USER_SUCCESS',
  DELETE_USER_FAILED = '[IDENTITY_MANAGEMENT] DELETE_USER_FAILED',

  CREATE_USER = '[IDENTITY_MANAGEMENT] CREATE_USER',
  CREATE_USER_SUCCESS = '[IDENTITY_MANAGEMENT] CREATE_USER_SUCCESS',
  CREATE_USER_FAILED = '[IDENTITY_MANAGEMENT] CREATE_USER_FAILED',

  UPDATE_USER = '[IDENTITY_MANAGEMENT] UPDATE_USER',
  UPDATE_USER_SUCCESS = '[IDENTITY_MANAGEMENT] UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILED = '[IDENTITY_MANAGEMENT] UPDATE_USER_FAILED',

  GET_LINKED_INSTALLERS = '[IDENTITY_MANAGEMENT] GET_LINKED_INSTALLERS',
  GET_LINKED_INSTALLERS_SUCCESS = '[IDENTITY_MANAGEMENT] GET_LINKED_INSTALLERS_SUCCESS',
  GET_LINKED_INSTALLERS_FAILED = '[IDENTITY_MANAGEMENT] GET_LINKED_INSTALLERS_FAILED',

  UNLINK_INSTALLER = '[IDENTITY_MANAGEMENT] UNLINK_INSTALLER',
  UNLINK_INSTALLER_SUCCESS = '[IDENTITY_MANAGEMENT] UNLINK_INSTALLER_SUCCESS',
  UNLINK_INSTALLER_FAILED = '[IDENTITY_MANAGEMENT] UNLINK_INSTALLER_FAILED',

  LINK_INSTALLER = '[IDENTITY_MANAGEMENT] LINK_INSTALLER',
  LINK_INSTALLER_SUCCESS = '[IDENTITY_MANAGEMENT] LINK_INSTALLER_SUCCESS',
  LINK_INSTALLER_FAILED = '[IDENTITY_MANAGEMENT] LINK_INSTALLER_FAILED',

  GET_COMPANY_BY_EMAIL = '[IDENTITY_MANAGEMENT] GET_COMPANY_BY_EMAIL',
  GET_COMPANY_BY_EMAIL_SUCCESS = '[IDENTITY_MANAGEMENT] GET_COMPANY_BY_EMAIL_SUCCESS',
  GET_COMPANY_BY_EMAIL_FAILED = '[IDENTITY_MANAGEMENT] GET_COMPANY_BY_EMAIL_FAILED',

  CREATE_CCAP_TOKENS = '[IDENTITY_MANAGEMENT] CREATE_CCAP_TOKENS',
  CREATE_CCAP_TOKENS_SUCCESS = '[IDENTITY_MANAGEMENT] CREATE_CCAP_TOKENS_SUCCESS',
  CREATE_CCAP_TOKENS_FAILED = '[IDENTITY_MANAGEMENT] CREATE_CCAP_TOKENS_FAILED',

  GET_CCAP_TOKENS = '[IDENTITY_MANAGEMENT] GET_CCAP_TOKENS',
  GET_CCAP_TOKENS_SUCCESS = '[IDENTITY_MANAGEMENT] GET_CCAP_TOKENS_SUCCESS',
  GET_CCAP_TOKENS_FAILED = '[IDENTITY_MANAGEMENT] GET_CCAP_TOKENS_FAILED',

  REVOKE_CCAP_TOKEN = '[IDENTITY_MANAGEMENT] REVOKE_CCAP_TOKEN',
  REVOKE_CCAP_TOKEN_SUCCESS = '[IDENTITY_MANAGEMENT] REVOKE_CCAP_TOKEN_SUCCESS',
  REVOKE_CCAP_TOKEN_FAILED = '[IDENTITY_MANAGEMENT] REVOKE_CCAP_TOKEN_FAILED',
}

export const getAuthInfoIdentityManagementAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_IDENTITY_MANAGEMENT);
export const getAuthInfoIdentityManagementSuccessAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_IDENTITY_MANAGEMENT_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoIdentityManagementFailedAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_IDENTITY_MANAGEMENT_FAILED);

export const getAuthInfoForCompanyAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_FOR_COMPANY, props<IDataAction<string>>());
export const getAuthInfoForCompanySuccessAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_FOR_COMPANY_SUCCESS, props<IDataAction<{ companyId: string, permissions: Partial<ApiPermissions> }>>());
export const getAuthInfoForCompanyFailedAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_FOR_COMPANY_FAILED, props<IDataAction<string>>());

export const getAuthInfoForUserAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_FOR_USER, props<IDataAction<string>>());
export const getAuthInfoForUserSuccessAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_FOR_USER_SUCCESS, props<IDataAction<IUserPermissions>>());
export const getAuthInfoForUserFailedAction = createAction(IdentityManagementActionsTypes.GET_AUTH_INFO_FOR_USER_FAILED, props<IDataAction<string>>());

export const getDealerCompaniesAction = createAction(IdentityManagementActionsTypes.GET_DEALER_COMPANIES, props<IDataAction<IGetCompaniesData>>());
export const getDealerCompaniesSuccessAction = createAction(IdentityManagementActionsTypes.GET_DEALER_COMPANIES_SUCCESS, props<IDataAction<Company[]>>());
export const getDealerCompaniesFailedAction = createAction(IdentityManagementActionsTypes.GET_DEALER_COMPANIES_FAILED);

export const getRetailerCompaniesAction = createAction(IdentityManagementActionsTypes.GET_RETAILER_COMPANIES, props<IDataAction<IGetCompaniesData>>());
export const getRetailerCompaniesSuccessAction = createAction(IdentityManagementActionsTypes.GET_RETAILER_COMPANIES_SUCCESS, props<IDataAction<Company[]>>());
export const getRetailerCompaniesFailedAction = createAction(IdentityManagementActionsTypes.GET_RETAILER_COMPANIES_FAILED);

export const getInstallerCompaniesAction = createAction(IdentityManagementActionsTypes.GET_INSTALLER_COMPANIES, props<IDataAction<IGetCompaniesData>>());
export const getInstallerCompaniesSuccessAction = createAction(IdentityManagementActionsTypes.GET_INSTALLER_COMPANIES_SUCCESS, props<IDataAction<Company[]>>());
export const getInstallerCompaniesFailedAction = createAction(IdentityManagementActionsTypes.GET_INSTALLER_COMPANIES_FAILED);

export const getCompaniesAction = createAction(IdentityManagementActionsTypes.GET_COMPANIES, props<IDataAction<IGetCompaniesData>>());
export const getCompaniesSuccessAction = createAction(IdentityManagementActionsTypes.GET_COMPANIES_SUCCESS, props<IDataAction<Company[]>>());
export const getCompaniesFailedAction = createAction(IdentityManagementActionsTypes.GET_COMPANIES_FAILED);

export const getCompanyInfoAction = createAction(IdentityManagementActionsTypes.GET_COMPANY_INFO, props<IDataAction<string>>());
export const getCompanyInfoSuccessAction = createAction(IdentityManagementActionsTypes.GET_COMPANY_INFO_SUCCESS, props<IDataAction<CompanyDetails>>());
export const getCompanyInfoFailedAction = createAction(IdentityManagementActionsTypes.GET_COMPANY_INFO_FAILED);

export const updateCompanyAction = createAction(IdentityManagementActionsTypes.UPDATE_COMPANY, props<IDataAction<IUpdateCompany>>());
export const updateCompanySuccessAction = createAction(IdentityManagementActionsTypes.UPDATE_COMPANY_SUCCESS, props<IDataAction<CompanyDetails>>());
export const updateCompanyFailedAction = createAction(IdentityManagementActionsTypes.UPDATE_COMPANY_FAILED);

export const createCompanyAction = createAction(IdentityManagementActionsTypes.CREATE_COMPANY, props<IDataAction<INewCompany>>());
export const createCompanySuccessAction = createAction(IdentityManagementActionsTypes.CREATE_COMPANY_SUCCESS, props<IDataAction<CompanyDetails>>());
export const createCompanyFailedAction = createAction(IdentityManagementActionsTypes.CREATE_COMPANY_FAILED);

export const getUsersAction = createAction(IdentityManagementActionsTypes.GET_USERS, props<IDataAction<IGetUsersData>>());
export const getUsersSuccessAction = createAction(IdentityManagementActionsTypes.GET_USERS_SUCCESS, props<IDataAction<User[]>>());
export const getUsersFailedAction = createAction(IdentityManagementActionsTypes.GET_USERS_FAILED);

export const getUserAction = createAction(IdentityManagementActionsTypes.GET_USER, props<IDataAction<string>>());
export const getUserSuccessAction = createAction(IdentityManagementActionsTypes.GET_USER_SUCCESS, props<IDataAction<User>>());
export const getUserFailedAction = createAction(IdentityManagementActionsTypes.GET_USER_FAILED);

export const getUserDetailsAction = createAction(IdentityManagementActionsTypes.GET_USER_DETAILS, props<IDataAction<string>>());
export const getUserDetailsSuccessAction = createAction(IdentityManagementActionsTypes.GET_USER_DETAILS_SUCCESS, props<IDataAction<UserDetails>>());
export const getUserDetailsFailedAction = createAction(IdentityManagementActionsTypes.GET_USER_DETAILS_FAILED);

export const deleteUserDetailsAction = createAction(IdentityManagementActionsTypes.DELETE_USER, props<IDataAction<string>>());
export const deleteUserDetailsSuccessAction = createAction(IdentityManagementActionsTypes.DELETE_USER_SUCCESS, props<IDataAction<string>>());
export const deleteUserDetailsFailedAction = createAction(IdentityManagementActionsTypes.DELETE_USER_FAILED);

export const createUserAction = createAction(IdentityManagementActionsTypes.CREATE_USER, props<IDataAction<INewUser>>());
export const createUserSuccessAction = createAction(IdentityManagementActionsTypes.CREATE_USER_SUCCESS, props<IDataAction<UserDetails>>());
export const createUserFailedAction = createAction(IdentityManagementActionsTypes.CREATE_USER_FAILED);

export const updateUserDetailsAction = createAction(IdentityManagementActionsTypes.UPDATE_USER, props<IDataAction<IUpdateUser>>());
export const updateUserDetailsSuccessAction = createAction(IdentityManagementActionsTypes.UPDATE_USER_SUCCESS, props<IDataAction<UserDetails>>());
export const updateUserDetailsFailedAction = createAction(IdentityManagementActionsTypes.UPDATE_USER_FAILED);

export const getLinkedInstallersAction = createAction(IdentityManagementActionsTypes.GET_LINKED_INSTALLERS, props<IDataAction<string>>());
export const getLinkedInstallersSuccessAction = createAction(IdentityManagementActionsTypes.GET_LINKED_INSTALLERS_SUCCESS, props<IDataAction<CompanyLink[]>>());
export const getLinkedInstallersFailedAction = createAction(IdentityManagementActionsTypes.GET_LINKED_INSTALLERS_FAILED);

export const unlinkInstallerAction = createAction(IdentityManagementActionsTypes.UNLINK_INSTALLER, props<IDataAction<IUnlinkOrLinkInstaller>>());
export const unlinkInstallerSuccessAction = createAction(IdentityManagementActionsTypes.UNLINK_INSTALLER_SUCCESS, props<IDataAction<CompanyLink[]>>());
export const unlinkInstallerFailedAction = createAction(IdentityManagementActionsTypes.UNLINK_INSTALLER_FAILED);

export const linkInstallerAction = createAction(IdentityManagementActionsTypes.LINK_INSTALLER, props<IDataAction<IUnlinkOrLinkInstaller>>());
export const linkInstallerSuccessAction = createAction(IdentityManagementActionsTypes.LINK_INSTALLER_SUCCESS, props<IDataAction<CompanyLink[]>>());
export const linkInstallerFailedAction = createAction(IdentityManagementActionsTypes.LINK_INSTALLER_FAILED);

export const getCompanyByEmailAction = createAction(IdentityManagementActionsTypes.GET_COMPANY_BY_EMAIL, props<IDataAction<string>>());
export const getCompanyByEmailSuccessAction = createAction(IdentityManagementActionsTypes.GET_COMPANY_BY_EMAIL_SUCCESS, props<IDataAction<CompanyLinkCompany>>());
export const getCompanyByEmailFailedAction = createAction(IdentityManagementActionsTypes.GET_COMPANY_BY_EMAIL_FAILED);

export const createCcapTokensAction = createAction(IdentityManagementActionsTypes.CREATE_CCAP_TOKENS, props<IDataAction<INewCcapTokens>>());
export const createCcapTokensSuccessAction = createAction(IdentityManagementActionsTypes.CREATE_CCAP_TOKENS_SUCCESS, props<IDataAction<CcapTokenDetails[]>>());
export const createCcapTokensFailedAction = createAction(IdentityManagementActionsTypes.CREATE_CCAP_TOKENS_FAILED, props<IDataAction<INewCcapTokens>>());

export const getCcapTokensAction = createAction(IdentityManagementActionsTypes.GET_CCAP_TOKENS, props<IDataAction<string>>());
export const getCcapTokensSuccessAction = createAction(IdentityManagementActionsTypes.GET_CCAP_TOKENS_SUCCESS, props<IDataAction<CcapTokenDetails[]>>());
export const getCcapTokensFailedAction = createAction(IdentityManagementActionsTypes.GET_CCAP_TOKENS_FAILED, props<IDataAction<string>>());

export const revokeCcapTokenAction = createAction(IdentityManagementActionsTypes.REVOKE_CCAP_TOKEN, props<IDataAction<IRevokeCcapToken>>());
export const revokeCcapTokenSuccessAction = createAction(IdentityManagementActionsTypes.REVOKE_CCAP_TOKEN_SUCCESS, props<IDataAction<CcapTokenDetails>>());
export const revokeCcapTokenFailedAction = createAction(IdentityManagementActionsTypes.REVOKE_CCAP_TOKEN_FAILED, props<IDataAction<IRevokeCcapToken>>());

export const setCompanyAction = createAction(IdentityManagementActionsTypes.SET_COMPANY, props<IDataAction<Company>>());
